<template>
  <div class="template-mapping">
    <main class="message">
    <b-card header-tag="header" footer-tag="footer">
      <div slot="header">
        <i className="fa fa-align-justify"></i><strong>{{ this.$t('TEMPLATE.MAPPINGS') }}</strong>
      </div>
      <b-list-group :style="{ maxHeight: this.containerHeight + 'px' }">
        <div v-if="blankTemplateMappings">
          <b-card>
            No mappings added
          </b-card>
        </div>
        <div role="tablist" class="map-tree">
          <v-tree ref='tree' :data='this.templateMappings' :tpl="customTemplate" />
        </div>
      </b-list-group>
    </b-card>
    </main>

  </div>
</template>

<script>

export default {
  props: ['templateMappings', 'mappings', 'isLatestVersion'],
  data () {
    return {
      listTypes: [
        { value: null, text: 'Please select data type' },
        { value: 'alpha', text: 'Alphabets' },
        { value: 'alphanumeric', text: 'Alphanumeric' },
        { value: 'alphanumeric_with_space', text: 'Alphanumeric With Spaces' },
        { value: 'numeric_with_decimal', text: 'Numeric With Decimal' },
        { value: 'checkbox', text: 'Checkbox' },
        { value: 'city', text: 'City' },
        { value: 'cod', text: 'COD' },
        { value: 'date', text: 'Date' },
        { value: 'email', text: 'Email' },
        { value: 'fax', text: 'Fax' },
        { value: 'npi', text: 'NPI' },
        { value: 'numeric', text: 'Numeric' },
        { value: 'phone', text: 'Phone' },
        { value: 'signature', text: 'Signature' },
        { value: 'state', text: 'State' },
        { value: 'text', text: 'Text' },
        { value: 'zip', text: 'ZIP' }
      ],
      updateMapping: {
        key: null,
        type: null,
        description: null,
        required: false,
        extract: true,
        extract_by_words: false,
        redact_field: true,
        show_field: true,
        sensitiveData: false,
        order: null,
        uniqId: null
      },
      containerHeight: 0
    }
  },
  computed: {
    blankTemplateMappings () {
      return this.mapTreeData && this.mapTreeData.length === 0
    }
  },
  mounted () {
    this.$root.$on('setHeightMappings', (Height) => {
      this.containerHeight = Height
    })
  },
  beforeDestroy () {
    this.$root.$off('setHeightMappings', this.containerHeight)
  },
  methods: {
    editMapping (node) {
      this.$emit('nodeSelected', node)
    },
    highlight (node) {
      this.removeHighlight()
      if (node.type !== 'Layer') {
        this.mappings.find('Rect').forEach(shape => {
          if (shape.attrs.key && node.title.toLowerCase() === shape.attrs.key.toLowerCase()) {
            shape.setAttrs({
              fillEnabled: true,
              name: 'selected',
              fill: 'yellow',
              opacity: 0.5
            })
          } else if (shape.attrs.parentKey && node.title.toLowerCase() === shape.attrs.parentKey.toLowerCase()) {
            shape.setAttrs({
              fillEnabled: true,
              name: 'selected',
              fill: (shape.index > 0) ? '#63c2de' : 'yellow',
              opacity: 0.5
            })
          }
        })
      }
      this.mappings.draw()
    },
    removeHighlight () {
      this.mappings.find('.selected').forEach(shape => {
        shape.setAttrs({
          name: '',
          fillEnabled: false,
          opacity: 1.0
        })
      })
    },
    customTemplate (node, ctx) {
      let titleClass = node.required ? 'node-title node-title-required' : 'node-title'
      let order = node.order ? ' - (' + node.order + ')' : ''
      if (this.isLatestVersion) {
        return <span class={titleClass} domPropsInnerHTML={node.title + (node.date_format ? ' (' + node.date_format + ')' : '') + order} onMouseover={() => this.highlight(node)} onClick={() => this.editMapping(node)}></span>
      } else {
        return <span class={titleClass} domPropsInnerHTML={node.title + (node.date_format ? ' (' + node.date_format + ')' : '') + order} onMouseover={() => this.highlight(node)}></span>
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.template-mapping {
  .card-body {
    margin: 0 0.5rem 0.5rem 0.5rem;
    padding: 0rem 0.2rem 0.2rem 0.2rem;
    background-color: white;
    overflow-y: scroll;
  }
}

main.message {
  padding-right: 0;
  padding-left: 0;
}

.mapping-title {
  background: aliceblue;
}

.card-header{
  background-color: #EAEFF2;
  .btn { margin-top: 0; }
}

.card { background-color: #EAEFF2; }

.map-tree {
  .halo-tree {
    padding-left: 0;
  }

  .node-edit {
    color: #20a8d8;
  }

  .node-delete {
    color: #f86c6b;
  }

  .node-title-required::after {
    color: red;
    content: '*';
    margin-left: 1px;
    font-weight: bolder;
    font-size: 1.2em;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/templates/templateMappings.vue